import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "warehousex.product.logo.v1";

// WarehouseX Product Logo. Distinct from the PrimeS4 platform/partner mark.
// Used in the Admin / Consultant / Client sidebar headers and the login
// screen — anywhere the *product* identity should lead. Falls back to the
// "WarehouseX" wordmark when no logo has been uploaded.
function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.logo === "string") return parsed.logo;
  } catch { /* ignore */ }
  return null;
}

function writeCache(logo) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ logo, fetched_at: Date.now() })); }
  catch { /* quota exceeded — non-critical */ }
}

export default function useProductLogo() {
  const [logo, setLogo] = useState(() => readCache() || "");

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/branding/public`).then((r) => {
      if (cancelled) return;
      const next = (r.data || {}).product_logo || "";
      setLogo(next);
      writeCache(next);
    }).catch(() => { /* keep cached value on transient errors */ });
    return () => { cancelled = true; };
  }, []);

  return logo;
}
